module.exports = __webpack_public_path__ + "static/media/b-sci-major-19_LR.1a6e4947.jpg";